module.exports = __webpack_public_path__ + "img/bg1.9e77b6f9.png";